import React from 'react'

import s from './ArrowLink.scss'


const ArrowLink = ({ title, direction, onClick }) => (
  <div className={s[direction]} onClick={onClick}>
    {title}
  </div>
)


export default ArrowLink
